import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AppState, APP_FEATURE_KEY } from "./reducers";

const getAppState = createFeatureSelector<AppState>(APP_FEATURE_KEY);

const getSemtIDFromState = createSelector(
    getAppState,
    (state: AppState) => state.semtID
);

const getCredentialFromStore = createSelector(
    getAppState,
    (state: AppState) => state.credential
);

const getUserDataFromStore = createSelector(
    getAppState,
    (state: AppState) => state.userData
);

const getBrandDataFromStore = createSelector(
    getAppState,
    (state: AppState) => state.brandData
);

const getNewBrandOwnerDataFromStore = createSelector(
    getAppState,
    (state: AppState) => state.newBrandOwner
);

const getNewBrandDataFromStore = createSelector(
    getAppState,
    (state: AppState) => state.newBrand
);

const getNewBrandOwnerCredFromStore = createSelector(
    getAppState,
    (state: AppState) => state.newBrandOwnerCred
);

const getNewFileUrlFromStore = createSelector(
    getAppState,
    (state: AppState) => state.newFileUrl
);

const getAllBrandsFromStore = createSelector(
    getAppState,
    (state: AppState) => state.allBrands
);

const getTempBrandOwnerDataFromStore = createSelector(
    getAppState,
    (state: AppState) => state.tempBrandOwnerData
);

const getTempBrandDataFromStore = createSelector(
    getAppState,
    (state: AppState) => state.tempBrandData
);

export const appQuery = {
    getSemtID: getSemtIDFromState,
    getCredential: getCredentialFromStore,
    getUserData: getUserDataFromStore,
    getBrandData: getBrandDataFromStore,
    getNewBrandOwnerData: getNewBrandOwnerDataFromStore,
    getNewBrandData: getNewBrandDataFromStore,
    getNewBrandOwnerCred: getNewBrandOwnerCredFromStore,
    getNewFileUrl: getNewFileUrlFromStore,
    getAllBrands: getAllBrandsFromStore,
    getTempBrandOwnerData: getTempBrandOwnerDataFromStore,
    getTempBrandData: getTempBrandDataFromStore
}